import moment from 'moment';
import SettingsUtils from 'utils/SettingsUtils';
import { API } from '../constants/api';
import qs from 'qs';
import { BASE_URL } from '../constants/api';
import features from './features.json';

class SubscriptionUtils {
  getQueryParams() {
    try {
      const query = window.location.search.substring(1);
      const pairs = {};
      const vars = query.split('&');
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        pairs[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
      }
      return pairs;
    } catch (e) {
      return {};
    }
  }

  isAdminMode() {
    // Check URL parameter
    const queryParams = this.getQueryParams();
    if (queryParams.admin === 'true') {
      return true;
    }

    // Check localStorage for click-activated admin mode
    try {
      const storedAdminState = localStorage.getItem('survcart_admin_mode');
      if (storedAdminState === 'true') {
        return true;
      }
    } catch (e) {
      // localStorage might not be available in some environments
      console.warn('localStorage not available for admin mode check');
    }

    return false;
  }

  getSubscriptionLevel(company) {
    // Check for admin mode (URL param or localStorage)
    if (this.isAdminMode()) {
      return 3; // Force Premium tier for admin users
    }

    if (company) {
      if (company.subscription && company.subscription.tier) {
        return company.subscription.tier;
      }
    }
  }

  getSubscriptionPlanName(company) {
    let tier = this.getSubscriptionLevel(company);
    if (!tier) {
      tier = 2; // Early-Bird
    }

    return features.tiers[tier].title;
  }

  hasFeatureAccess(company, feature) {
    if (this.isAdminMode()) {
      return true;
    }

    let featureSchema = features.features[feature];
    let tier =
      company && company.subscription && company.subscription.tier
        ? company.subscription.tier
        : 2;
    if (featureSchema) {
      return tier >= featureSchema.tier_minimum;
    } else {
      console.error('No feature schema for feature: ' + feature);
    }

    return false;
  }

  getUserCost(billingFrequency) {
    if (billingFrequency !== undefined) {
      return billingFrequency === 'monthly' ? 8 : 7;
    }
  }

  getPhoneNumberCost(billingFrequency) {
    if (billingFrequency !== undefined) {
      return billingFrequency === 'monthly' ? 10 : 10;
    }
  }

  getCostMultiplier(billingFrequency) {
    if (billingFrequency !== undefined) {
      if (billingFrequency === 'yearly') {
        return 12;
      } else {
        return 1;
      }
    }
  }

  getBillingEnding(billingFrequency) {
    if (billingFrequency !== undefined) {
      return billingFrequency === 'monthly' ? 'mo' : 'year';
    }
  }

  updatePlan(plan, memberId) {
    let params = {
      method: 'POST',
      body: JSON.stringify({
        plan: plan,
        memberId: memberId,
      }),
    };
    return fetch(`${BASE_URL}/httpStripeSubscriptionUpdate`, params);
  }

  getSMSCost() {
    return 0.015;
  }
}

export default new SubscriptionUtils();
